import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { PaquetesService } from 'src/app/services/paquetes.service';

@Component({
  selector: 'app-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.scss']
})
export class CategoriasComponent implements OnInit {

  respuestaGet:any;
  respuestaAgregar:any;
  categorias:any;

  categoriaId:any;

  formulario:any;
  formularioEdit:any;

  data:any;
  datos:any;

  constructor(private _getPaquetes: PaquetesService, private modalService:NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }

    this.getCategorias();
  }

  getCategorias(){
    this._getPaquetes.getCategorias().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.categorias = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  editarCategoria(categoria:number){
    this.data = {
      'categoria':categoria,
    }
    this._getPaquetes.editarCategoria(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datos = this.respuestaGet.content;
          this.formularioEdit.nombre = this.datos.nombre;
          this.categoriaId = this.datos.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    ) 
  }

  updateCategoria(){
    this.data = {
      'categoria':this.categoriaId,
      'nombre':this.formularioEdit.nombre
    }
   
    this._getPaquetes.updateCategoria(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getCategorias();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarCategoria(){
    this.data = {
      'nombre': this.formulario.nombre
    }
  
    this._getPaquetes.agregarCategoria(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.codigo = '';
          this.dismissAll();
          this.getCategorias();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }
}
